export default __webpack_public_path__ + "b70670f5aa80cbf485a207406a5a5416.png";